module.exports = __webpack_public_path__ + "static/media/table-list-solid-full.8c8d69ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/table-list-solid-full.svg
// module id = 2585
// module chunks = 0